<template>
  <div class="container-fluid">
    <div style="margin-bottom: 15px">
      <router-link to="metodologia">
        <button class="btn btn-outline-secondary">
          <i class="bi bi-arrow-left-circle"></i> Voltar
        </button>
      </router-link>
    </div>

    <div>
      <table class="table table-sm table-hover">
        <thead>
          <tr>
            <th class="align-middle text-center" scope="col">ID</th>
            <th class="align-middle" scope="col">Name</th>
            <th class="align-middle" scope="col">Bot</th>
            <th class="align-middle" scope="col">Sender</th>
            <th class="align-middle" scope="col">Token Curso</th>
            <th class="align-middle text-center" scope="col">Qt Cursos</th>
            <th class="align-middle" scope="col">Cliente</th>
            <th class="align-middle" scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="loading !== true" v-for="project in this.list_projetcts" :key="project.id">
            <th class="align-middle text-center" scope="row">{{ project.id }}</th>
            <td class="align-middle">{{ project.name }}</td>
            <td class="align-middle">{{ project.bot_name }}</td>
            <td class="align-middle">{{ project.sender_phone }}</td>
            <td class="align-middle">{{ project.token_course }}</td>
            <td class="align-middle text-center">{{ project.count_of_courses }}</td>
            <td class="align-middle">{{ project.client_name }}</td>
            <td class="align-middle">
              <div class="dropdown">
                <button
                  class="btn btn-secondary dropdown-toggle"
                  type="button"
                  data-toggle="dropdown"
                  aria-expanded="false"
                >
                  Opções
                </button>
                <div class="dropdown-menu">
                  <a class="dropdown-item" href="#">Ver mais</a>
                  <a class="dropdown-item" data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" aria-controls="offcanvasWithBothOptions" href="#">Ir para Cursos</a>
                </div>
              </div>
            </td>
          </tr>
          <tr v-else>
            <td colspan="9" class="align-middle text-center">
              <Loader />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
    
<script>
import { http } from "../../http";
import Loader from "../shared/painel/Loader.vue";

export default {
  name: "Projetos",
  components: {
      Loader,
  },
  data() {
    return {
      loading: true,
      project_filter: null,
      list_projetcts: null,
    };
  },
  mounted() {
    this.list_all_projects();
  },
  methods: {
    list_all_projects: async function () {
      var payload = {
        project_filter: null,
      };

      await http.post("list_all_projects/", payload)
      .then((res) => this.list_projetcts = res.data)
      .finally(() => {
        setTimeout(() => {
          this.loading = false
        }, 1000);
      });
    },
  },
};
</script>    

<style>
</style>
    